import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"var(--details)","display":"flex","flex-direction":"column","align-items":"center","margin-bottom":"45px"}},[_c('Titles',{attrs:{"type":2,"text":'Departamentos'}}),_vm._l((_vm.departamentos),function(departamento){return _c(VCol,{key:departamento.id,attrs:{"cols":"12","md":"9"}},[_c('Departaments',{attrs:{"departamento":departamento.attributes}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }